import classnames from 'classnames';
import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { CloseButton, SourceIcon, Text, Tooltip, WixIcons } from '../../../../../components/common';
import { useRootFolder } from '../../../../../utils/hoc/withRootFolder';
import styles from './SourceItem.scss';
import { IOuter } from './SourceItem.types';

const moveBy = { x: 20 };
export const SourceItem: FC<IOuter> = ({
  source,
  selectedSource,
  isConnected,
  isPermanent,
  sourceClassName,
  onSourceChange,
  onDisconnectClick,
}) => {
  const rootFolder = useRootFolder(source);
  const isActive = source === selectedSource;

  const onClick = useCallback(() => {
    onSourceChange(source);
  }, [onSourceChange, source]);

  const onDisconnectButtonClick = useCallback(
    (event) => {
      event.stopPropagation();
      onDisconnectClick(source);
    },
    [onDisconnectClick, source],
  );

  return (
    <Text
      weight="thin"
      size="small"
      tagName="li"
      className={classnames(styles.wrapper, {
        [styles.active]: isActive,
      })}
      onClick={onClick}
      dataHook={`source-${source}-item-wrapper`}
    >
      <div className={styles.icon}>
        <SourceIcon source={source} />
      </div>

      <div className={classnames(styles.sourceName, sourceClassName)}>{rootFolder.name}</div>

      {isConnected && !isPermanent && (
        <Tooltip
          content={<FormattedMessage id="files-importer.disconnect-tooltip.disconnect" />}
          placement="right"
          moveBy={moveBy}
        >
          <CloseButton
            className={styles.disconnectButton}
            size="small"
            skin="lightFilled"
            onClick={onDisconnectButtonClick}
            dataHook="disconnect-button"
          >
            <WixIcons.X />
          </CloseButton>
        </Tooltip>
      )}
    </Text>
  );
};
